'use strict';

angular
  .module('systemOwnerReviewControllers.ConfirmSystemOwnership')

  .controller('ExplanationReviewUniquePermissionsController', [
    '$scope',
    '$state',
    '$translate',
    'topBar',
    function ($scope, $state, $translate, topBar) {
      $translate('iam.admin.systemOwnerReview.reviewUniquePermissions.pageTitle').then(function (translation) {
        topBar.setTitleAndIcon(translation, 'fa-gavel');
      });

      $scope.goToNextExplanationStep = function (step) {
        $state.go(
          'systemOwnerReview.authUser.reviewUniquePermissionsExplanationStep' + step,
          { authLogin: $scope.authLogin },
          { reload: true }
        );
      };
    },
  ]);
